<template>
  <div>
    <div>
    <b-nav class="main-nav">
    <b-nav-item class="logo">
    <img src="../assets/img/logo.png"/>
    </b-nav-item>
    <b-nav-item class="logout"
                               @click="dashboard()">
                               Dashboard
    </b-nav-item>
    </b-nav>
    </div>
    <div class="profile-div col-sm-6">
      <h5 class="mt-3 mb-3"> Support </h5>
      <b-form @submit.prevent="support('formRegistration')"
              class="ml-4 mr-4 mb-4"
              data-vv-scope="formRegistration">
        <b-form-group id="nameGroup">
          <b-row class="my-0">
            <b-col sm="4">
              <label for="input-small">First Name</label>
            </b-col>
            <b-col sm="8">
              <b-form-input id="firstName"
                          type="text"
                          name="firstName"
                          v-model="firstName"
                          v-validate="'required'"
                          :class="{'input': true,
                                   'is-danger': errors.has('formRegistration.firstName') }"
                          required
                          placeholder="First Name">
               </b-form-input>
              <i v-show="errors.has('formRegistration.firstName')" class="fa fa-warning"></i>
              <span v-show="errors.has('formRegistration.firstName')"
                    class="help is-danger">{{ errors.first('formRegistration.firstName') }}
              </span>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-0">
            <b-col sm="4">
              <label for="input-small">Last Name</label>
            </b-col>
            <b-col sm="8">
              <b-form-input id="lastName"
                          type="text"
                          name="lastName"
                          v-model="lastName"
                          v-validate="'required'"
                          :class="{'input': true,
                                   'is-danger': errors.has('formRegistration.lastName') }"
                          required
                          placeholder="Last Name">
               </b-form-input>
              <i v-show="errors.has('formRegistration.lastName')" class="fa fa-warning"></i>
              <span v-show="errors.has('formRegistration.lastName')"
                    class="help is-danger">{{ errors.first('formRegistration.lastName') }}
              </span>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-0">
            <b-col sm="4">
              <label for="input-small">Email Address</label>
            </b-col>
            <b-col sm="8">
              <b-form-input id="emailAddress"
                          type="email"
                          name="emailAddress"
                          v-model="emailAddress"
                          v-validate="'required'"
                          :class="{'input': true,
                                   'is-danger': errors.has('formRegistration.emailAddress') }"
                          required
                          placeholder="Email Address">
               </b-form-input>
              <i v-show="errors.has('formRegistration.emailAddress')" class="fa fa-warning"></i>
              <span v-show="errors.has('formRegistration.emailAddress')"
                    class="help is-danger">{{ errors.first('formRegistration.emailAddress') }}
              </span>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-0">
            <b-col sm="4">
              <label for="input-small">Support Type</label>
            </b-col>
          <b-col sm="8">
            <b-form-select v-model="supportType"
                           name="supportType"
                           id="supportType"
                           class="mb-2"
                           :options="options"
                           v-validate="'required'"
                           :class="{'input': true,
                                    'is-danger': errors.has('formRegistration.supportType') }"
                           required>
            </b-form-select>
            <i v-show="errors.has('formRegistration.supportType')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.supportType')"
                  class="help is-danger">{{ errors.first('formRegistration.supportType') }}
            </span>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-0">
            <b-col sm="4">
              <label for="input-small">Message</label>
            </b-col>
            <b-col sm="8">
              <b-form-textarea id="message"
                          type="text"
                          name="message"
                          :rows="5"
                          v-model="message"
                          v-validate="'required'"
                          :class="{'input': true,
                                   'is-danger': errors.has('formRegistration.message') }"
                          required
                          placeholder="Message">
               </b-form-textarea>
              <i v-show="errors.has('formRegistration.message')" class="fa fa-warning"></i>
              <span v-show="errors.has('formRegistration.message')"
                    class="help is-danger">{{ errors.first('formRegistration.message') }}
              </span>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"></label>
            </b-col>
            <b-col sm="8">
                        <vue-recaptcha
                          ref="recaptcha"
                          @verify="onVerify"
                          @expired="onExpired"
                          sitekey="6LfNiFMUAAAAAIvrde8Hq-aeNyI-OA5R30sKrLJv">
                        </vue-recaptcha>
            </b-col>
          </b-row>
        </b-form-group>
        <b-button
          type="submit"
          class="w-100"
          :disabled="disabledButton"
          variant="warning">Submit</b-button>
      </b-form>
      <b-modal hide-footer v-model="modalShow" @hidden="redirect()" title="Thank You">
      Thank you for contacting us, our support team will be in touch shortly.
    </b-modal>
    </div>
  </div>
</template>

<script>
import API from '@/api';
import Session from '@/Session';
import FacitHeader from '@/components/header';
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'facitSupport',
  components: { FacitHeader, VueRecaptcha },
  data() {
    return {
      message: null,
      supportType: null,
      modalShow: false,
      disabledButton: true,
      firstName: null,
      lastName: null,
      emailAddress: null,
      options: [
        { value: null, text: 'Select Support Type' },
        { value: 'Technical Support', text: 'Technical Support' },
        { value: 'Billing Support', text: 'Billing Support' },
        { value: 'Other', text: 'Other' },
      ],
    };
  },
  created() {
    const customMessage = {
    custom: {
      emailAddress: {
        required: 'The Email Field is Required',
      },
      firstName: {
        required: 'The First Name is Required'
      },
      lastName: {
        required: 'The Last Name is Required'
      },
      supportType: {
        required: 'The Support Type is Required'
      },
      message: {
        required: 'The Message is Required'
      },
    },
  };
  this.$validator.localize('en', customMessage);
},
  methods: {
    async support(scope) {
      try {
        const validation = await this.$validator.validateAll(scope);
        if (validation) {
          await API.post(`Accounts/facitSupportEmail`, {
            email: this.emailAddress,
            firstname: this.firstName,
            lastname: this.lastName,
            message: this.message,
            supportType: this.supportType,
          });
          this.modalShow = true;
        }
      } catch (error) {
        this.$notify({
          group: 'sitewide',
          title: 'Error!',
          type: 'error',
          text: 'Error while sending Email',
        });
      }
    },
    async onVerify(response) {
      if (response) {
        this.disabledButton = false;
      }
    },
    onExpired() {

    },
    dashboard() {
      this.$router.push('peoplecounting');
    },
    redirect() {
      this.$router.push('peoplecounting');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #656580 !important
}
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}
.main-nav {
  background-color: #2c3e50 !important;
  height: 90px;
  min-width: 100%;
  width: 100%;
}
.logo {
  margin-top: 20px;
  margin-left: 30px;
  width: 80%;
}
.logo2 {
  margin-top: 20px;
  margin-left: 30px;
  width: 55%;
}
.nav-link-custom {
    background: white;
    border: #fe5623;
    color: #656580 !important;
}
.logout {
  margin-top: 28px;
}
li > a > span{
  color: #656580 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/facitSupport.vue